import { FC } from 'react';
import styled from 'styled-components';

import { WidgetContainer } from '@/features/vfo/components';
import { ApiDashboardResponseV2 } from '@/shared/api';
import { breakpoints, media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';

type DocumentsDashboardProps = {
  analyticsData?: ApiDashboardResponseV2;
};

export const DocumentsDashboard: FC<DocumentsDashboardProps> = ({ analyticsData }) => {
  const { t } = useTranslation('features/vfo', {
    keyPrefix: 'documents.dashboard',
  });
  const documentsAnalytics = analyticsData?.allDocuments.analytics.kpi;

  return (
    <Container>
      <WidgetContainerStyled
        titleClassName="titleWrapper"
        icon="file"
        size="small"
        title={`${documentsAnalytics?.totalDocuments ?? 0} ${t('totalDocuments')}`}
      />
      <WidgetContainerStyled
        titleClassName="titleWrapper"
        icon="notification"
        size="small"
        title={`${documentsAnalytics?.newDocuments ?? 0} ${t('newDocuments')}`}
      />
    </Container>
  );
};

const WidgetContainerStyled = styled(WidgetContainer)`
  flex: 1;

  ${media.md}, ${breakpoints.sm} {
    padding: 0 !important;
    .titleWrapper {
      flex-direction: column;
      gap: 6px;
    }
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  ${media.md}, ${breakpoints.sm} {
    background: ${COLORS.white};
    border-radius: 16px;
    padding: 16px;
  }
`;
